export default __webpack_public_path__ + "static/media/404.4b2f85c3.svg";